<div class="flex">
  @if (global) {
    <app-indicator-children-dropdown />
  }
  <app-search-input
    class="ml-auto"
    [disabled]="!data"
    (search)="filterFeatures($event)"></app-search-input>
</div>
<div class="p-datatable" *ngIf="data">
  <p-scrollPanel [style]="{ height: '35rem' }">
    <table class="p-datatable-table w-full">
      <thead class="p-datatable-thead">
        <tr>
          <th><i class="fas fa-key"></i></th>
          <th>Name</th>
          <th>Wert</th>
        </tr>
      </thead>
      <tbody class="p-datatable-tbody">
        @if (data.avg || hasErrors('avg') || hasWarnings('avg')) {
          <tr
            class="font-italic"
            [class]="
              hasErrors('avg')
                ? 'font-bold text-red-500'
                : hasWarnings('avg')
                  ? 'font-bold text-yellow-500'
                  : 'text-color-secondary'
            ">
            <td><code>avg</code></td>
            <td>Durchschnitt</td>
            <td>
              <span
                >{{
                  hasErrors('avg')
                    ? getErrorValue('avg') + ' (wird als k. A. importiert)'
                    : data.avg
                      ? (data.avg | safeNumber: data.indicator)
                      : 'k.A.'
                }}
                @if (data['warning']?.oldValues?.['avg']; as oldValue) {
                  <i class="font-light"
                    >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
                  >
                }
              </span>
            </td>
          </tr>
        }

        @if (data.total || hasErrors('total') || hasWarnings('total')) {
          <tr
            class="font-italic"
            [class]="
              hasErrors('total')
                ? 'font-bold text-red-500'
                : hasWarnings('total')
                  ? 'font-bold text-yellow-500'
                  : 'text-color-secondary'
            ">
            <td><code>total</code></td>
            <td>Gesamt</td>
            <td>
              <span
                >{{
                  hasErrors('total')
                    ? getErrorValue('total') + ' (wird als k. A. importiert)'
                    : data.total
                      ? (data.total | safeNumber: data.indicator)
                      : 'k.A.'
                }}
                @if (data['warning']?.oldValues?.['total']; as oldValue) {
                  <i class="font-light"
                    >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
                  >
                }
              </span>
            </td>
          </tr>
        }

        @for (
          compVal of comparisonStore.withoutDefaultAsArray();
          track $index
        ) {
          @if (data.data[compVal.key]) {
            <tr
              class="font-italic"
              [class]="
                hasErrors(compVal.key)
                  ? 'font-bold text-red-500'
                  : hasWarnings(compVal.key)
                    ? 'font-bold text-yellow-500'
                    : 'text-color-secondary'
              ">
              <td>
                <code>{{ compVal.key }}</code>
              </td>
              <td>{{ compVal.name }}</td>
              <td
                [innerHTML]="
                  data.data[compVal.key]
                    ? (data.data[compVal.key] | safeNumber: data.indicator)
                    : 'k.A.'
                "></td>
            </tr>
          }
        }
        @for (district of filteredDistricts | keyvalue; track district.key) {
          <tr
            [class]="
              hasErrors(district.key)
                ? 'font-bold text-red-500'
                : hasWarnings(district.key)
                  ? 'font-bold text-yellow-500'
                  : 'text-color-secondary'
            ">
            <td>
              <code>{{ district.key }}</code>
            </td>
            <td>{{ district.value.name }}</td>
            <td>
              <span
                >{{
                  hasErrors(district.key)
                    ? getErrorValue(district.key) +
                      ' (wird als k. A. importiert)'
                    : data.data[district.key]
                      ? (data.data[district.key] | safeNumber: data.indicator)
                      : 'k.A.'
                }}
                @if (data['warning']?.oldValues?.[district.key]; as oldValue) {
                  <i class="font-light"
                    >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
                  >
                }
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </p-scrollPanel>
</div>
